import React, { Component,useEffect,useState } from 'react';
import Piechart from '../../common/piechart';
import Columnchart from '../../common/columnchart';
import Stackedchart from '../../common/stackedchart';
import Sparklineschart from '../../common/sparklineschart';
import { Link } from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import Donutchart from '../../common/donutchart';
import Donutchart1 from '../../common/donutchart1';
import Donutchart2 from '../../common/donutchart2';
import Barchart from '../../common/barchart';
import Barchart1 from '../../common/barchart1';
import LineChart from '../../common/Linechart';
import LineChart1 from '../../common/Linechart1';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { API_BASE_URL } from "../../../config"; // or use process.env
import TopTile from "../../../components/HRMS/Dashboard/TopTile";
import BirthdayToday from "../../../components/HRMS/Dashboard/BirthdayToday"
import JoiningToday from "../../../components/HRMS/Dashboard/JoiningToday"
import WorkingAnniversary from "../../../components/HRMS/Dashboard/WorkingAnniversary"







const Dasboard = (props) => {
	const { fixNavbar } = props;

	
	const location=useLocation();
	const history = useHistory();

	const [count, setCount] = useState(0);
  	// const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(true);
  	const [tiles, setTiles] = useState({
    people: 0, total_ctc: 0,
    links: { employees: "/hr-employees", leave: "/Hr-leave", timesheet: "/attendance" }
  });

 
  


  useEffect(() => {
    const token = localStorage.getItem("authToken");
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/activeEmployeesCount`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
        setTiles(data);

		if (data?.user_role_id === 1 || data?.user_role_id === 3 || data?.user_role_id === 8) {
  history.replace("/dashboard");   // same dashboard
} else {
  history.replace("/employee-dashboard");
}
		
      } catch (e) {
        console.error("dashboard summary failed:", e?.message || e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


   useEffect(() => {
    const token = localStorage.getItem("authToken");
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/birthdaysToday`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
        setRows(data?.data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


  const fmt = (n) => (n ?? 0).toLocaleString(); // format numbers like 8138095 -> 8,138,095


       
// 	 useEffect(() => {
//     const token = localStorage.getItem("authToken"); // remove if not needed
//     (async () => {
//       try {
//         const { data } = await axios.get(`${API_BASE_URL}/activeEmployeesCount`, {
//           headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//         });
//         setCount(data?.count ?? 0);
//       } catch (e) {
//         console.error("active-count fetch failed:", e?.message || e);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);
  
	// const data = history.location.state.data;


	// if(!data) {
    //     return history.push('/login');
    // }


	
const now = new Date();
  const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(now);
  const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(now);
  const month = new Intl.DateTimeFormat("en-GB", { month: "long" }).format(now);
  const year = new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(now);


	




	return (
		<>
			<div>
				<div className={`section-body ${fixNavbar ? "marginTop" : ""} mt-3`}>
					<div className="container-fluid">
						{/* <div className="row clearfix">
								<div className="col-lg-12">
									<div className={`section-body ${fixNavbar ? "mb-4 mt-3" : "mb-4"}`}>
										<h5>Welcome Jason Porter!</h5>
										<small>
											Measure How Fast You’re Growing Monthly Recurring Revenue.{' '}
											<a href="fake_url">Learn More</a>
										</small>
									</div>
								</div>
							</div> */}


			<div className="px-3 py-2 mb-3" style={{lineHeight: 1.1}}>
      <div style={{ fontSize: 14, color: "#3a3a3a" }}>
        Welcome back, <span style={{ fontWeight: 600 }}>{tiles.name}</span>!
      </div>
      <div className="text-muted" style={{ fontSize: 11, marginTop: 4 }}>
        Today is {weekday}, {day} {month} {year}
      </div>
    </div>

	<hr className="mb-4" />


							<div className="row g-3 mb-3">
            <TopTile
              iconClass="icon-users"
              label="People"
              value={fmt(tiles.people)}
              to={tiles.links?.employees}
              loading={loading}
            />
            <TopTile
              iconClass="icon-credit-card"
              label="Total CTC"
              value={fmt(tiles.total_ctc)}
              loading={loading}
            />
            <TopTile
              iconClass="icon-calendar"
              label="Leave"
              subtitle="Management"
              to={tiles.links?.leave}
              loading={loading}
            />
            <TopTile
              iconClass="icon-clock"
              label="Timesheet"
              subtitle="Attendance"
              to={tiles.links?.timesheet}
              loading={loading}
            />
          </div>



						{/* <div className="row clearfix">
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body ribbon">
										 <div className="ribbon-box green">5</div>
										<Link to="/hr-employees" className="my_sort_cut text-muted">
											<i className="icon-users" style={{fontSize: '25px'}} />
											<span style={{fontSize: '15px'}}>Users  {loading ? "…" : count.toLocaleString()}</span>
											 {<a className="text-muted"><i className="ft-arrow-up" />{loading ? "…" : count.toLocaleString()}</a> 
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body">
										<Link to="/hr-holidays" className="my_sort_cut text-muted">
											<i className="icon-like" />
											<span>Holidays</span>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body ribbon">
										<div className="ribbon-box orange">8</div>
										<Link to="/hr-events" className="my_sort_cut text-muted">
											<i className="icon-calendar" />
											<span>Events</span>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body">
										<Link to="/hr-payroll" className="my_sort_cut text-muted">
											<i className="icon-credit-card" />
											<span>Payroll</span>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body">
										<Link to="/hr-accounts" className="my_sort_cut text-muted">
											<i className="icon-calculator" />
											<span>Accounts</span>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 col-md-4 col-xl-2">
								<div className="card">
									<div className="card-body">
										<Link to="/hr-report" className="my_sort_cut text-muted">
											<i className="icon-pie-chart" />
											<span>Report</span>
										</Link>
									</div>
								</div>
							</div>
						</div> */}
					</div>
				</div>

               





				<div className="section-body">
					<div className="container-fluid">

						<div className="row clearfix">
				<div className="col-12">
					<BirthdayToday />
				</div>
				</div>


				

						<div className="row clearfix">
				<div className="col-12">
					<JoiningToday />
				</div>
				</div>


				<div className="row clearfix">
				<div className="col-12">
					<WorkingAnniversary />
				</div>
				</div>


				<div className="row clearfix row-deck">
							<div className="col-xl-12 col-lg-12 col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Department Attendance</b></h3>
										
									</div>
									<div className="card-body">
										<LineChart></LineChart>
									</div>
									
								</div>
							</div>
							</div>


						<div className="row clearfix row-deck">
							<div className="col-xl-12 col-lg-12 col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Attendance</b></h3>
										
									</div>
									<div className="card-body">
										<LineChart1></LineChart1>
									</div>
									
								</div>
							</div>
							</div>


						<div className="row clearfix row-deck">
							<div className="col-xl-6 col-lg-12 col-md-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Monthly CTC Amount Group</b></h3>
										
									</div>
									<div className="card-body">
										<Barchart1></Barchart1>
									</div>
									
								</div>
							</div>
							<div className="col-xl-6 col-lg-6 col-md-6">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Department Wise Monthly CTC</b></h3>
									</div>
									<Donutchart2 />

									{/* <Piechart></Piechart> */}

									
									
								</div>
							</div>
							
						</div>
						<div className="row clearfix row-deck">
							<div className="col-xl-4 col-lg-6 col-md-6">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Age Group</b></h3>
									</div>
									<div className="card-body">
								
									<Barchart></Barchart>
								</div>

									{/* <div className="card-body text-center">
												<div className="row clearfix">
													<div className="col-6">
														<h6 className="mb-0">50</h6>
														<small className="text-muted">Male</small>
													</div>
													<div className="col-6">
														<h6 className="mb-0">17</h6>
														<small className="text-muted">Female</small>
													</div>
												</div>
											</div> */}
								</div>
							</div>
							<div className="col-xl-4 col-lg-6 col-md-6">
								<div className="card">
									<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Gender Split</b></h3>
									</div>
									<Donutchart />

									{/* <div className="card-footer text-center">
												<div className="row clearfix">
													<div className="col-6">
														<h6 className="mb-0">$3,095</h6>
														<small className="text-muted">Last Year</small>
													</div>
													<div className="col-6">
														<h6 className="mb-0">$2,763</h6>
														<small className="text-muted">This Year</small>
													</div>
												</div>
											</div> */}
								</div>
									
								</div>
							</div>
							<div className="col-xl-4 col-lg-6 col-md-6">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title"><b>Department Split</b></h3>
									</div>
									<Donutchart1 />

									
								</div>
							</div>
						</div>
						{/* <div className="row clearfix">
							<div className="col-12 col-sm-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title">Project Summary</h3>
									</div>
									<div className="card-body">
										<div className="table-responsive">
											<table className="table table-hover table-striped text-nowrap table-vcenter mb-0">
												<thead>
													<tr>
														<th>#</th>
														<th>Client Name</th>
														<th>Team</th>
														<th>Project</th>
														<th>Project Cost</th>
														<th>Payment</th>
														<th>Status</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>#AD1245</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>Angular Admin</td>
														<td>$14,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#DF1937</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>Angular Admin</td>
														<td>$14,500</td>
														<td>Pending</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#YU8585</td>
														<td>Merri Diamond</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
															</ul>
														</td>
														<td>One page html Admin</td>
														<td>$500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-orange">Submit</span>
														</td>
													</tr>
													<tr>
														<td>#AD1245</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
															</ul>
														</td>
														<td>Wordpress One page</td>
														<td>$1,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#GH8596</td>
														<td>Allen Collins</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>VueJs Application</td>
														<td>$9,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</>
	);

}
const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar
})

const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Dasboard);